module.exports = __webpack_public_path__ + "u81.png?55a6563bfeae92ed5bd4f67115702213";


//////////////////
// WEBPACK FOOTER
// ./static/assets/u81.png
// module id = 419
// module chunks = 0